module.exports = __webpack_public_path__ + "static/media/sunwise-main.1d4e20bb.jpg";